// start:ng42.barrel
import './mortgage-detail-editor.component';
import './mortgage-status-editor.component';
// end:ng42.barrel

